import yaml from 'js-yaml'
import { VALIDATION_ERRORS } from './keyboard-scene/constants.js'

export async function parseSwitchPositions(yamlPath) {
  if (!yamlPath) {
    throw new Error(VALIDATION_ERRORS.MISSING_REQUIRED_FIELD('yamlPath'))
  }

  let response
  try {
    response = await fetch(yamlPath)
  } catch (error) {
    throw new Error(VALIDATION_ERRORS.FILE_NOT_FOUND(yamlPath))
  }

  if (!response.ok) {
    throw new Error(VALIDATION_ERRORS.NETWORK_ERROR(yamlPath, response.status))
  }

  let yamlText
  try {
    yamlText = await response.text()
  } catch (error) {
    throw new Error(VALIDATION_ERRORS.NETWORK_ERROR(yamlPath, 'Failed to read response'))
  }

  let data
  try {
    data = yaml.load(yamlText)
  } catch (error) {
    throw new Error(VALIDATION_ERRORS.YAML_PARSE_ERROR(yamlPath, error.message))
  }

  if (!data || typeof data !== 'object') {
    throw new Error(VALIDATION_ERRORS.YAML_PARSE_ERROR(yamlPath, 'Invalid YAML structure'))
  }

  const positions = []
  for (const [key, value] of Object.entries(data)) {
    if (value && typeof value === 'object' && 'x' in value && 'y' in value) {
      const x = parseFloat(value.x)
      const y = parseFloat(value.y)
      const r = parseFloat(value.r) || 0

      if (isNaN(x) || isNaN(y)) {
        throw new Error(`Invalid coordinates for position ${key}: x=${value.x}, y=${value.y}`)
      }

      positions.push({
        name: key,
        x,
        y,
        r,
        meta: value.meta || {}
      })
    }
  }

  if (positions.length === 0) {
    throw new Error(VALIDATION_ERRORS.YAML_PARSE_ERROR(yamlPath, 'No valid switch positions found'))
  }

  return positions
}

export async function loadRotationData(rotationPath) {
  if (!rotationPath) {
    return null
  }

  let response
  try {
    response = await fetch(rotationPath)
  } catch (error) {
    throw new Error(VALIDATION_ERRORS.FILE_NOT_FOUND(rotationPath))
  }

  if (!response.ok) {
    throw new Error(VALIDATION_ERRORS.NETWORK_ERROR(rotationPath, response.status))
  }

  let rotationData
  try {
    rotationData = await response.json()
  } catch (error) {
    throw new Error(VALIDATION_ERRORS.NETWORK_ERROR(rotationPath, 'Invalid JSON format'))
  }

  return rotationData
}